import React__default, { useState, useEffect } from 'react';
import { FormControl, Box, Select, MenuItem, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KLanguageSwitcher from '../../KLanguageSwitcher/index.js';

var FrontEditPagesTabContentLayout = function (_a) {
    var _b;
    var className = _a.className, pages = _a.pages, currentPageKey = _a.currentPageKey, onPageChange = _a.onPageChange, locales = _a.locales, onLocaleChange = _a.onLocaleChange, _c = _a.testId, testId = _c === void 0 ? "FrontEditPagesTabContent" : _c;
    var _d = useTranslation("refront-components"), t = _d.t, i18n = _d.i18n;
    var _e = useState(), selectedPage = _e[0], setSelectedPage = _e[1];
    useEffect(function () {
        if (currentPageKey) {
            setSelectedPage(pages.find(function (p) { return p.key === currentPageKey; }));
        }
    }, [currentPageKey, pages]);
    var handleSelectOnChange = function (key) {
        onPageChange(key);
        var selectedPage = pages.find(function (p) { return p.key === key; });
        if (selectedPage) {
            setSelectedPage(selectedPage);
        }
    };
    var count = function () {
        var _a;
        if (selectedPage) {
            var totalEditableContentSectionLength_1 = 0;
            (_a = selectedPage.sections) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
                var editableContents = _a.editableContents;
                return (totalEditableContentSectionLength_1 =
                    totalEditableContentSectionLength_1 + editableContents.length);
            });
            return totalEditableContentSectionLength_1;
        }
        return 0;
    };
    return (React__default.createElement(FormControl, { className: clsx("FrontEditPagesTabContent", className), "data-testid": testId, sx: { width: "100%" } },
        React__default.createElement(Box, { component: "nav", sx: {
                display: "flex",
                flexWrap: "wrap",
                rowGap: "1rem",
                justifyContent: "space-between"
            } },
            React__default.createElement(Select, { value: (selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.key) || currentPageKey, onChange: function (e) {
                    handleSelectOnChange(e.target.value);
                }, autoWidth: true, variant: "standard", sx: {
                    display: "flex",
                    justifyContent: "left"
                }, MenuProps: { disableScrollLock: true } }, pages.map(function (page) { return (React__default.createElement(MenuItem, { key: page.key, value: page.key }, page.label)); })),
            onLocaleChange && locales && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Typography, { sx: {
                        display: "flex",
                        justifyContent: "end"
                    } }, t("components-front-edit.pageContent.in.locale.label")),
                React__default.createElement(KLanguageSwitcher, { locales: locales !== null && locales !== void 0 ? locales : [], currentLocale: i18n.language, onChange: function (event) {
                        onLocaleChange(event.target.value);
                    } }))),
            React__default.createElement(Typography, { "data-testid": "frontEditEditableCount", sx: {
                    display: "flex",
                    justifyContent: "end"
                } }, t("components-front-edit.pageContent.component.label", {
                count: count()
            }))),
        selectedPage &&
            ((_b = selectedPage.sections) === null || _b === void 0 ? void 0 : _b.map(function (s, i) { return (React__default.createElement(Box, { key: i },
                s && s.title && (React__default.createElement(Typography, { sx: {
                        fontWeight: function (theme) { return theme.typography.fontWeightBold; },
                        fontSize: function (theme) { return theme.typography.fontSize; },
                        display: "flex",
                        justifyContent: "left",
                        marginTop: 4,
                        marginLeft: 2,
                        borderBottom: "1px solid grey"
                    } }, s.title)),
                React__default.createElement(Box, { "data-testid": "frontEditEditableContent-".concat(i), sx: {
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: function (theme) { return theme.spacing(2); },
                        marginTop: 2
                    } }, s.editableContents.map(function (w) { return w; })))); }))));
};

export { FrontEditPagesTabContentLayout as default };
//# sourceMappingURL=index.js.map
